import { useState, useEffect } from "react";
import { authApi } from "../../services/api";

export default function MyProfile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState("");

  useEffect(() => {
    authApi.me()
      .then((res) => setProfile(res.data.data))
      .catch(() => setError("Failed to load profile."))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 300, color: "var(--text-muted)" }}>
      Loading...
    </div>
  );

  if (error) return (
    <div style={{ color: "var(--color-error, #f87171)", padding: "24px" }}>{error}</div>
  );

  const fields = [
    { label: "Name",        value: profile.name || "—",                          icon: "👤" },
    { label: "Username",    value: profile.username,                              icon: "🔖" },
    { label: "Email",       value: profile.email,                                 icon: "📧" },
    { label: "Role",        value: profile.role,                                  icon: "🛡️" },
    { label: "2FA",         value: profile.twoFaEnabled ? "Enabled" : "Disabled", icon: "🔐", highlight: profile.twoFaEnabled },
    { label: "Status",      value: profile.active ? "Active" : "Inactive",        icon: "✅", highlight: profile.active },
  ];

  const avatarLetter = (profile.name || profile.username || "A")[0].toUpperCase();

  return (
    <div style={{ maxWidth: 680, margin: "0 auto", padding: "32px 24px" }}>

      {/* Header */}
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "var(--text-primary)", marginBottom: 28 }}>
        My Profile
      </h1>

      {/* Avatar Card */}
      <div style={{
        background: "var(--bg-card)",
        border: "1px solid var(--border-color)",
        borderRadius: 16,
        padding: "32px 24px",
        display: "flex",
        alignItems: "center",
        gap: 20,
        marginBottom: 20,
        boxShadow: "0 2px 12px rgba(0,0,0,0.15)"
      }}>
        <div style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #0f6b72, #1a9ea8)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 28,
          fontWeight: 700,
          color: "#fff",
          flexShrink: 0,
          boxShadow: "0 4px 16px rgba(15,107,114,0.4)"
        }}>
          {avatarLetter}
        </div>
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "var(--text-primary)" }}>
            {profile.name || profile.username}
          </div>
          <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 4 }}>
            {profile.email}
          </div>
          <span style={{
            display: "inline-block",
            marginTop: 8,
            padding: "3px 12px",
            borderRadius: 999,
            fontSize: 11,
            fontWeight: 600,
            background: "rgba(15,107,114,0.18)",
            color: "#4fd1c5",
            letterSpacing: "0.05em"
          }}>
            {profile.role}
          </span>
        </div>
      </div>

      {/* Details Card */}
      <div style={{
        background: "var(--bg-card)",
        border: "1px solid var(--border-color)",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 2px 12px rgba(0,0,0,0.15)"
      }}>
        {fields.map(({ label, value, icon, highlight }, idx) => (
          <div key={label} style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 24px",
            borderBottom: idx < fields.length - 1 ? "1px solid var(--border-color)" : "none",
            transition: "background 0.15s",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 16 }}>{icon}</span>
              <span style={{ fontSize: 13, color: "var(--text-muted)", fontWeight: 500 }}>{label}</span>
            </div>
            <span style={{
              fontSize: 14,
              fontWeight: 600,
              color: highlight === true
                ? "#4ade80"
                : highlight === false && label !== "Name" && label !== "Username" && label !== "Email"
                  ? "#f87171"
                  : "var(--text-primary)"
            }}>
              {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}